import MyStoresPage from './MyStoresPage'

export default MyStoresPage
